import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { api } from './api.js';
import { requestPersistence } from './db/db.js';
import { syncer } from './sync/sync.js';
import { useApp } from './state.js';
import Login from './features/Login.js';
import ErrorBoundary from './ui/ErrorBoundary.js';

export default function App(): JSX.Element {
  const { authenticated, setAuthenticated, loadSettings, setSync, toast } = useApp();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    void (async () => {
      try {
        const res = await api.get<{ authenticated: boolean }>('/api/auth/status');
        setAuthenticated(res.authenticated);
      } catch {
        // Offline: se já existe caderno local, deixa entrar e trabalhar.
        setAuthenticated(localStorage.getItem('cv.settings') !== null);
      } finally {
        setChecking(false);
      }
    })();
  }, [setAuthenticated]);

  useEffect(() => {
    if (!authenticated) return;
    void loadSettings();
    void requestPersistence();
    void syncer.run();
    return syncer.subscribe((state, pending, lastAt) => setSync({ state, pending, lastAt }));
  }, [authenticated, loadSettings, setSync]);

  if (checking) return <div className="center"><p className="muted">Abrindo o caderno…</p></div>;
  if (!authenticated) return <Login />;

  return (
    <div className="app">
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      {toast ? <div className="toast">{toast}</div> : null}
    </div>
  );
}
